import type { UserProfileResponse } from "@paperclipai/shared";
import { api } from "./client";

export type CompanyUserProfileResponse = UserProfileResponse & {
  usageAvailable?: boolean;
  activityNote?: string;
};

export const USER_PROFILE_UNAVAILABLE = "User profile details are unavailable from the server.";

export const userProfilesApi = {
  get: async (companyId: string, userSlug: string): Promise<CompanyUserProfileResponse> => {
    const payload = await api.get<CompanyUserProfileResponse>(
      `/companies/${companyId}/users/${encodeURIComponent(userSlug)}/profile`,
    );
    // OTC compatibility servers may return a flat placeholder identity instead.
    // Never render it as a verified company user or fabricate usage statistics.
    if (!payload?.user || typeof payload.user.id !== "string"
      || typeof payload.user.slug !== "string"
      || !Array.isArray(payload.stats) || !Array.isArray(payload.daily)
      || !Array.isArray(payload.recentIssues) || !Array.isArray(payload.recentActivity)
      || !Array.isArray(payload.topAgents) || !Array.isArray(payload.topProviders)) {
      throw new Error(USER_PROFILE_UNAVAILABLE);
    }
    return payload;
  },
};
